const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/documents.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import moment from 'moment';
import { KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const LOAD_REPORTS = kisapiActionTypes('PATAPP_LOAD_REPORTS');

export function loadReports(mindat: string, maxdat: string) {
    const params = {
        mindat: moment(mindat).format(KISIM_TIME_FORMAT),
        maxdat: moment(maxdat).format(KISIM_TIME_FORMAT),
    };

    const queryString = new URLSearchParams(params).toString();
    const endpoint = `/documents/reports?${queryString}`;
    return createPatapiCall(LOAD_REPORTS, endpoint, HttpMethod.GET);
}

export const LOAD_PDF = kisapiActionTypes('PATAPP_LOAD_PDF');
export type LoadPDFEndpoint = 'PatReports' | 'Image';

export function actionLoadPDF(endpoint: LoadPDFEndpoint, code: string, sender: string) {
    const meta = { endpoint, sender, code, suppressErrorMsg: false };
    let part;
    switch (endpoint) {
        case 'PatReports':
            part = 'pdfs';
            break;
        case 'Image':
        default:
            part = 'images';
            break;
    }
    return createPatapiCall(LOAD_PDF, `/documents/${part}/id/${sender}/${code}`, HttpMethod.GET, meta);
}

export const SAVE_SIGNED_PDF = kisapiActionTypes('SAVE_SIGNED_PDF');

export function saveSignedPDF(sender: string, code: string, workid: string, signedPdf: string) {
    const endpoint = `/documents/pdfs/id/${sender}/${code}/sign`;
    const meta = { sender, pdfNumber: code };
    return createPatapiCall(
        SAVE_SIGNED_PDF,
        endpoint,
        HttpMethod.POST,
        meta,
        JSON.stringify({ Buffer: signedPdf, WORKID: workid })
    );
}

export const LOAD_REPORTS_TO_SIGN = kisapiActionTypes('LOAD_REPORTS_TO_SIGN');

export function loadReportsToSign() {
    const endpoint = `/documents/pdfs/toSign`;
    return createPatapiCall(LOAD_REPORTS_TO_SIGN, endpoint);
}

export const LOAD_SIGNED_REPORTS = kisapiActionTypes('LOAD_SIGNED_REPORTS');

export function loadSignedReports() {
    const endpoint = `/documents/pdfs/signed`;
    return createPatapiCall(LOAD_SIGNED_REPORTS, endpoint);
}

export const LOAD_PDF_READ_CONFIRMATIONS = kisapiActionTypes('LOAD_PDF_READ_CONFIRMATIONS');

export function loadPDFReadConfirmations() {
    const endpoint = `documents/pdfs/read`;
    const meta = { suppressErrorMsg: true };
    return createPatapiCall(LOAD_PDF_READ_CONFIRMATIONS, endpoint, HttpMethod.GET, meta);
}

export const SAVE_PDF_READ_CONFIRMATION = kisapiActionTypes('SAVE_PDF_READ_CONFIRMATION');

export function savePDFReadConfirmation(sender: string, reportNr: string, documentTitle: string) {
    const endpoint = `/documents/pdfs/id/${sender}/${reportNr}/read`;
    const meta = { suppressErrorMsg: true, reportNr: reportNr };

    const body = {
        DocumentTitle: documentTitle,
    };

    return createPatapiCall(SAVE_PDF_READ_CONFIRMATION, endpoint, HttpMethod.POST, meta, JSON.stringify(body));
}

export const LOAD_INVOICES = kisapiActionTypes('LOAD_INVOICES');

export function loadInvoices() {
    const endpoint = `/documents/invoices`;
    const meta = { suppressErrorMsg: true };
    return createPatapiCall(LOAD_INVOICES, endpoint, HttpMethod.GET, meta);
}
